<div class="d-flex">
  @switch (viewType) {
    @case ('button') {
      <button
        class="btn gradient print icon-download w-100"
        (click)="export()">
        Export as PDF
      </button>
    }
    @case ('icon') {
      <button
        class="btn icon-download"
        matTooltip="Export data as PDF"
        (click)="export()">
      </button>
    }
    @case ('text') {
      @if (tables) {
        <div
          class="pointer p-10 c-secondary"
          (click)="export()">
          {{label}}
        </div>
      }
      @if (collection) {
        <div
          class="pointer p-10 c-secondary"
          (click)="exportToXLSX()">
          {{label}}
        </div>
      }
    }
  }
</div>
